import { http } from './http';
import { baseURL, wpUsersEndpoint } from './wpConfig';
import { ApplicationPassword, User } from './types';
import { UserCredentials } from './wpAuth';

export const getMyUserInfo = (userCredentials: UserCredentials): Promise<User> => {
    const endPoint: string = baseURL + wpUsersEndpoint + "/me?context=edit";
    return http.get<User>(endPoint, { auth: userCredentials });
};

export const getCurrentApplicationPassword = (userCredentials: UserCredentials): Promise<ApplicationPassword> => {
    const endPoint: string = baseURL + wpUsersEndpoint + "/me/application-passwords/introspect";
    return http.get<ApplicationPassword>(endPoint, { auth: userCredentials });
};

export const revokeApplicationPassword = (userCredentials: UserCredentials): Promise<{ deleted: boolean, previous: ApplicationPassword }> => {
    const endPoint: string = baseURL + wpUsersEndpoint + "/me/application-passwords/" + userCredentials.uuid;
    return http.del<{ deleted: boolean, previous: ApplicationPassword }>(endPoint, { auth: userCredentials });
};

export const updateMyUserMeta = (
    userCredentials: UserCredentials,
    userId: number,
    meta: Record<string, string>
): Promise<User> => {
    const endPoint: string = baseURL + wpUsersEndpoint + "/" + userId + "?context=edit";
    return http.post<User>(endPoint, { meta }, { auth: userCredentials });
};


